import { DecimalPipe, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import { LOCALE_ID, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats, MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CoreModule, CustomTranslateLoader, DatePipe } from '@sla-ng/core';
import { CostAccountingModule } from '@sla-ng/cost-accounting';
import { ErrorMessageInterceptor } from '@sla-ng/cost-accounting/lib/interceptors/error-message.interceptor';
import { SlairCoreModule } from '@sla-ng/slair-core';
import { SlaSidenavModule, SlaSnackbarModule, SlaTopbarModule, SlaVersionCheckModule, UIMaterialModule } from '@sla-ng/ui-material';
import { ToastrModule } from 'ngx-toastr';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';


const CUSTOM_DATE_FORMAT: MatDateFormats = {
    parse: {
        dateInput: 'DD.MM.YYYY',
    },
    display: {
        dateInput: 'DD.MM.YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'DD.MM.YYYY',
        monthYearA11yLabel: 'MMM YYYY',
    },
};
registerLocaleData(localeDe);


@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: CustomTranslateLoader,
            },
        }),
        ToastrModule.forRoot({
            newestOnTop: true,
            preventDuplicates: true,
            positionClass: 'toast-top-right',
        }),
        CoreModule.forRoot(),
        UIMaterialModule,

        SlaTopbarModule,
        SlaSidenavModule,

        SlaSnackbarModule,
        MatNativeDateModule,
        SlaVersionCheckModule,
        MatTooltipModule,

        MatIconModule,
        CostAccountingModule.forRoot(),
        SlairCoreModule.forRoot(),
        MatButtonModule,
        AppRoutingModule,
    ],
    providers: [
        DatePipe,
        DecimalPipe,
        { provide: LOCALE_ID, useValue: 'de' },
        { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
        { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMAT },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorMessageInterceptor, multi: true },

    ],
    bootstrap: [ AppComponent ],
})
export class AppModule {
}

